var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefunded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.193,
    height: 13.061,
    viewBox: "0 0 15.193 13.061",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -35.935)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 35.935)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.618,39.5H2.271L5,36.774l-.839-.839L0,40.1l4.161,4.161L5,43.417,2.271,40.689H9.618a4.394,4.394,0,0,1,4.389,4.389,4.51,4.51,0,0,1-1.059,2.717l-.368.465.931.736.368-.465a5.677,5.677,0,0,0,1.314-3.452A5.582,5.582,0,0,0,9.618,39.5Z",
    transform: "translate(0 -35.935)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefunded);
export default __webpack_public_path__ + "static/media/refunded.f8234120.svg";
export { ForwardRef as ReactComponent };